import { render, staticRenderFns } from "./EditServiceTimesForType.vue?vue&type=template&id=437a35f1&scoped=true&"
import script from "./EditServiceTimesForType.vue?vue&type=script&lang=js&"
export * from "./EditServiceTimesForType.vue?vue&type=script&lang=js&"
import style0 from "./EditServiceTimesForType.vue?vue&type=style&index=0&id=437a35f1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437a35f1",
  null
  
)

export default component.exports